import { styled } from '@mui/material';

import { styledCustom } from '/styles';

const DIALOG_OFFSET = '176px';

export const ContainerStyled = styledCustom('div')<{ $fillDialog: boolean }>(({ $fillDialog }) => ({
  display: 'flex',
  position: 'relative',
  width: 'inherit',
  height: 'inherit',
  justifyContent: 'center',
  alignItems: 'center',
  ...($fillDialog && {
    width: `calc(100vw - ${DIALOG_OFFSET})`,
    height: `calc(100vh - ${DIALOG_OFFSET})`,
    maxWidth: '100%',
  }),
}));

export const IFrameStyled = styled('iframe')({
  border: 'none',
  width: '100%',
  height: '100%',
});
